import { render, staticRenderFns } from "./AnimationsModule.vue?vue&type=template&id=0fe4bb81&scoped=true"
import script from "./AnimationsModule.vue?vue&type=script&lang=js"
export * from "./AnimationsModule.vue?vue&type=script&lang=js"
import style0 from "./AnimationsModule.vue?vue&type=style&index=0&id=0fe4bb81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4bb81",
  null
  
)

export default component.exports